import { Teacher } from "../teacher/teacher";
import { SubSchool } from "./sub-school";

export type SchoolDto = {
  name: string;
  id: string;
  subSchools: SubSchool[];
  teachers: string[];
  secretary: string[];
};

export class School {
  constructor(
    public name: string,
    public id: string,
    public subSchools: SubSchool[],
    public teachers: Teacher[],
    public secretary: string[],
  ) {}

  static createFromSchoolDto(dto: SchoolDto, teachers: Teacher[]): School {
    return new School(
      dto.name,
      dto.id,
      dto.subSchools,
      teachers,
      dto.secretary,
    );
  }
}
